<template>
	<div ref="container" 
		class="overflow-hidden h-full">
		<div :style="iframeStyle" class="frame absolute overflow-hidden">
			<!-- <iframe class="w-full h-full" :src="src" /> -->
			<div ref="handstick" class="handstick absolute">
			</div>
		</div>
	</div>
</template>

<script>

import Player from '@vimeo/player';

export default {
	props: ['id', 'quality', 'visible'],
	computed: {
		ratio() {
			return this.h / this.w;
		},
		inverseRatio() {	
			return this.w / this.h;
		}
	},
	data() {
		return {
			player: false,
			iframeStyle: {
				width: 0,
				height: 0,
			},
			io: false,	
			ready: false,
			reducedMotion: false,

			w: 16,
			h: 9,

			options: {},
		}
	},


	watch: {
		visible(newVal) {
			if ( newVal ) {
				this.create();
			} else {
				this.destroy();
			}
		},
	},
	mounted() {
		window.addEventListener('resize', this.resize );
		const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
		const check = () => {
			if ( mediaQuery.matches ) {
				this.reducedMotion = true;
			} else {
				this.reducedMotion = false;
			}
		};

		check();
		mediaQuery.addEventListener('change', function () {
			check();
		});
	
		const options = {
			autoplay: false,
			id: this.id,
			muted: true,
			background: true,
			dnt: true,
			responsive: false
		};

		if ( this.quality ) {
			options.quality = this.quality;
		}
		
		this.options = options;

		
		if ( this.visible ) {
			this.create();
		}
		
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.resize );
	},
	methods: {
		create() {
			const $el = this.$refs.handstick;
			this.player = new Player( $el, this.options );
			if ( !this.reducedMotion ) {
				this.play();
			}
		},
		destroy() {
			this.ready = false;
			if ( this.player ) {
				this.player.destroy().then( () => {
					this.player = false;
				});
			}
		},
		play() {

			if ( this.player ) {
				
				const w = this.player.getVideoWidth().then( e => this.w = e );
				const h = this.player.getVideoHeight().then( e => this.h = e );
				const p = this.player.ready();

				Promise.all( [ w, h, p ] ).then( () => {
					
					this.resize();

					this.player.play().then( () => {
						this.ready = true;
					});
				});
			}
		},
		pause() {
			this.ready = false;
			this.player.pause();
		},
		resize() {
			const container = this.$refs.container;
			const w = container.offsetWidth;
			const h = container.offsetHeight;
			const windowRatio = h / w;

			if (windowRatio > this.ratio) {
				this.iframeStyle.width = `${h * (this.inverseRatio)}px`;
				this.iframeStyle.height = `${h}px`;
			} else {
				this.iframeStyle.width = `${w}px`;
				this.iframeStyle.height = `${w * (this.ratio)}px`;
			}
		}
	}
}
</script>

<style>
.frame iframe {
	width: 101%;
	height: 101%;
	position: relative;
	left: -0.5%;
	top: -0.5%;
}
</style>


<style scoped>


.frame {
	top: 50%;
	left: 50%;
	transform: translate(-50%,-50%);
	
}

.handstick {
	left: -2px;
	top: -2px;
	bottom: -2px;
	right: -2px;
}


</style>
